import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    container: {
        height: "100%",
    },
    image: {
        width: "100%",
    },
    containerDark: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginInline: theme.spacing(4),
        gap: theme.spacing(8),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.main,
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            marginInline: 0,
        },
    },
    marketing: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: "0 auto",
        maxWidth: 1180,
        padding: theme.spacing(7, 4),
        gap: theme.spacing(5),
        color: theme.palette.secondary.main,
    },
    inlineContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
}));
